module.exports = __webpack_public_path__ + "static/img/eight-steps.0e02b512.png";